<template>
  <div class="draft-list-item" @click="handle(item.detail_mobile_url)">
    <h4 class="ell">【{{ item.category_name }}】{{ item.item_name }}</h4>
    <p class="ell">来源: {{ item.source_name }}</p>
    <p class="ell">最新保存时间: {{ item.operate_time }}</p>
  </div>
</template>

<script>
export default {
  name: "DraftListItem",
  props: ['item'],
  methods: {
    handle(link) {
      location.href = link;
    }
  }
}
</script>

<style lang="scss" scoped>
.draft-list-item {
  padding: 15px;
  padding-right: 30px;
  margin-bottom: 15px;
  border: 1px solid #E5E5E5;
  border-radius: 5px;
  background: #fff;
  position: relative;
  h4 {
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  p {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: #999;
  }
  &:after{
    content: '';
    display: inline-block;
    width: 7px;
    height: 7px;
    border-top: 2px solid #999;
    border-right: 2px solid #999;
    position: absolute;
    top: 50%;
    right: 15px;
    margin-top: -4px;
    transform: rotate(45deg);
  }
}
.ell{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
